import { render, staticRenderFns } from "./AdminUserSettings.vue?vue&type=template&id=4d197ecd"
import script from "./AdminUserSettings.vue?vue&type=script&lang=js"
export * from "./AdminUserSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports